import { stripCohortSuffix } from 'helpers/stripCohortSuffix'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PagePath } from 'root-constants'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'
import { useZustandStore } from 'zustandGlobalStore'

export const useGAPageTracker = (): void => {
  const { pathname } = useLocation()
  const cohort = useZustandStore((state) => state.lead?.cohort)

  useEffect(() => {
    if (window.location.href.includes(PagePath.LOCALHOST)) return

    const cleanedPath = pathname.split('/').map(stripCohortSuffix).join('/')
    const currentOnboardingVariant = cohort ? `/${cohort}` : ''
    const currentLocation = `${cleanedPath}${currentOnboardingVariant}`
    googleAnalyticsLogger.logPageView(currentLocation)
  }, [pathname, cohort])
}
